import useInView from '../../Hooks/useInView'

const AnimateOnScroll = ({
  children,
  animation = 'fade-up',
  delay = 0,
  className = '',
  style = {},
  tag: Tag = 'div',
}) => {
  const [ref, isInView] = useInView()

  return (
    <Tag
      ref={ref}
      className={`${className} ${isInView ? `anim-${animation}` : 'anim-hidden'}`}
      style={{ animationDelay: delay ? `${delay}ms` : undefined, ...style }}
    >
      {children}
    </Tag>
  )
}

export default AnimateOnScroll
